import React, { FC } from 'react';
import classNames from 'classnames';
import { MaterialIcon } from '../../../components/material-icon/MaterialIcon';
import styles from './carousel_controller.module.scss';

type Props = {
  onClick: (event: React.MouseEvent<HTMLButtonElement, MouseEvent>) => void;
  direction: 'left' | 'right';
};

const icons = {
  left: 'keyboard_arrow_left',
  right: 'keyboard_arrow_right',
} as const;

export const CarouselController: FC<Props> = ({ onClick, direction }) => {
  return (
    <button
      className={classNames(
        styles.button,
        direction === 'left' && styles.left,
        direction === 'right' && styles.right,
      )}
      type="button"
      onClick={onClick}
    >
      <MaterialIcon name={icons[direction]} />
    </button>
  );
};
